import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { userService } from '../../_services';

export default function DashboardLayout({ children }) {
  const [user, setUser] = useState(userService.currentUserValue);

  useEffect(() => {
    const sub = userService.currentUser.subscribe(setUser);
    return () => sub.unsubscribe();
  }, []);

  const showsAgent = !user || user.type === 'showing_agent' || user.type === 'both';
  const showsBuyer = !user || user.type === 'buyer_agent' || user.type === 'both';

  return (
    <div className="wb-shell">
      <div className="wb-bar">
        <div className="wb-inner">
          {showsBuyer ? (
            <div className="wb-group">
              <span className="wb-label">Requesting</span>
              <NavLink className="wb-link" activeClassName="active" exact to="/showings/requests">
                <span className="fa fa-list"></span> My requests
              </NavLink>
              <NavLink className="wb-link wb-cta" activeClassName="active" to="/showings/post">
                <span className="fa fa-plus"></span> New showing
              </NavLink>
            </div>
          ) : null}

          {showsAgent ? (
            <div className="wb-group">
              <span className="wb-label">Covering</span>
              <NavLink className="wb-link" activeClassName="active" exact to="/showings/appointments">
                <span className="fa fa-calendar-check"></span> Appointments
              </NavLink>
              <NavLink className="wb-link" activeClassName="active" to="/jobs">
                <span className="fa fa-search-dollar"></span> Opportunities
              </NavLink>
              <NavLink className="wb-link" activeClassName="active" to="/map">
                <span className="fa fa-map-marked-alt"></span> Map
              </NavLink>
            </div>
          ) : null}

          <span className="wb-spacer" />

          <div className="wb-group wb-group-account">
            <NavLink className="wb-link" activeClassName="active" to="/users/profile/">
              <span className="icon-user"></span> Profile
            </NavLink>
            <NavLink className="wb-link" activeClassName="active" to="/reviews">
              <span className="fa fa-star"></span> Reviews
            </NavLink>
            {user && user.role === 'admin' ? (
              <NavLink className="wb-link" activeClassName="active" to="/admin">
                <span className="fa fa-shield-alt"></span> Admin
              </NavLink>
            ) : null}
          </div>
        </div>
      </div>
      <main className="wb-main">{children}</main>
    </div>
  );
}
